
import { socketActionCreators } from '../sockets';

export function connectWS () {
  return async dispatch => {
    dispatch(socketActionCreators.socketConnect())
  }
}
